import { HeadCell } from 'models';
import { AC_BASE_REQUEST_STATUS, SUBSCRIPTION_TYPE } from 'models/subscription';

export const statusLabel = {
  [AC_BASE_REQUEST_STATUS.PENDING_PAYMENT]: 'Pending Payment',
  [AC_BASE_REQUEST_STATUS.PAYMENT_COMPLETED]: 'Payment Completed',
  [AC_BASE_REQUEST_STATUS.PAYMENT_FAILED]: 'Payment Failed',
  [AC_BASE_REQUEST_STATUS.SEARCH_REQUESTED]: 'Search Requested',
  [AC_BASE_REQUEST_STATUS.SEARCH_FOUND]: 'Search Found',
  [AC_BASE_REQUEST_STATUS.PARENT_ACCEPTED]: 'Parent Accepted',
  [AC_BASE_REQUEST_STATUS.PARENT_REJECTED]: 'Parent Rejected',
  [AC_BASE_REQUEST_STATUS.TRIAL_CREATED]: 'Trial Created',
  [AC_BASE_REQUEST_STATUS.TRIAL_PAID]: 'Trial Paid',
  [AC_BASE_REQUEST_STATUS.TRIAL_COMPLETED]: 'Trial Completed',
  [AC_BASE_REQUEST_STATUS.ACTIVE]: 'Active',
  [AC_BASE_REQUEST_STATUS.INACTIVE]: 'Inactive',
  [AC_BASE_REQUEST_STATUS.CLOSED]: 'Closed',
};

export const statusColor = {
  [AC_BASE_REQUEST_STATUS.PENDING_PAYMENT]: 'rgba(255, 204, 0, 1)',
  [AC_BASE_REQUEST_STATUS.PAYMENT_COMPLETED]: 'rgba(34, 111, 227, 1)',
  [AC_BASE_REQUEST_STATUS.PAYMENT_FAILED]: 'rgba(255, 121, 110, 1)',
  [AC_BASE_REQUEST_STATUS.SEARCH_REQUESTED]: 'rgba(255, 121, 110, 1)',
  [AC_BASE_REQUEST_STATUS.SEARCH_FOUND]: 'rgba(255, 121, 110, 1)',
  [AC_BASE_REQUEST_STATUS.PARENT_ACCEPTED]: 'rgba(255, 121, 110, 1)',
  [AC_BASE_REQUEST_STATUS.PARENT_REJECTED]: 'rgba(255, 121, 110, 1)',
  [AC_BASE_REQUEST_STATUS.TRIAL_CREATED]: 'rgba(34, 111, 227, 1)',
  [AC_BASE_REQUEST_STATUS.TRIAL_PAID]: 'rgba(34, 111, 227, 1)',
  [AC_BASE_REQUEST_STATUS.TRIAL_COMPLETED]: 'rgba(34, 111, 227, 1)',
  [AC_BASE_REQUEST_STATUS.ACTIVE]: 'rgba(52, 199, 89, 1)',
  [AC_BASE_REQUEST_STATUS.INACTIVE]: 'rgba(142, 142, 147, 1)',
  [AC_BASE_REQUEST_STATUS.CLOSED]: 'rgba(142, 142, 147, 1)',
};

export const optionStatus = [
  {
    id: AC_BASE_REQUEST_STATUS.PENDING_PAYMENT,
    label: 'Pending Payment',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.PAYMENT_COMPLETED,
    label: 'Payment Completed',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.PAYMENT_FAILED,
    label: 'Payment Failed',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.SEARCH_REQUESTED,
    label: 'Search Requested',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.SEARCH_FOUND,
    label: 'Search Found',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.PARENT_ACCEPTED,
    label: 'Parent Accepted',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.TRIAL_CREATED,
    label: 'Trial Created',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.TRIAL_PAID,
    label: 'Trial Paid',
    disabled: true,
  },
  {
    id: AC_BASE_REQUEST_STATUS.TRIAL_COMPLETED,
    label: 'Trial Completed',
    disabled: true,
  },
  { id: AC_BASE_REQUEST_STATUS.ACTIVE, label: 'Active', disabled: true },
  { id: AC_BASE_REQUEST_STATUS.INACTIVE, label: 'Inactive' },
  { id: AC_BASE_REQUEST_STATUS.CLOSED, label: 'Closed' },
];

export const headCells: readonly HeadCell<SUBSCRIPTION_TYPE>[] = [
  {
    id: 'parent.subscription.number' as keyof SUBSCRIPTION_TYPE,
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Subscription No.',
  },
  {
    id: 'parent.User.first_name' as keyof SUBSCRIPTION_TYPE,
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Parent Name',
  },
  {
    id: 'start_datetime',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Start Datetime',
  },
  {
    id: 'end_datetime',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'End Datetime',
  },
  {
    id: 'address_id',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Short Address',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Created Date',
  },
];
